import convertToLocalDate from './convertToLocalDate';

export default convertToLocalDate;
